import { toDisplayString as _toDisplayString, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "flex flex--v flex--valign-s flex--gap-15"
}
const _hoisted_2 = { class: "text text--color-red text--size-18 text--semi-bold text--center" }
const _hoisted_3 = { class: "text text--accent-gray-b text--size-18 text--semi-bold text--center" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_ctx.hasErrors)
    ? (_openBlock(), _createBlock("div", _hoisted_1, [
        _createVNode("div", _hoisted_2, _toDisplayString(_ctx.$trans("auth.error")), 1),
        _createVNode("ul", _hoisted_3, [
          (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.errors, (error, key) => {
            return (_openBlock(), _createBlock("li", { key: key }, _toDisplayString(error), 1))
          }), 128))
        ])
      ]))
    : _createCommentVNode("", true)
}